export default {
    openapp: "打开APP",
    noStore: "门店不存在",
    rating: "评分:",
    Categories: "门店分类:",
    PreparationTime: "备餐时间:",
    DeliveryFee: "配送费",
    FreeDelivery:"免配送费",
    noScore: '暂无评分',
    discountTitle: '折扣',
    fullReductionTitle: '满减',
    storeFirstTitle: '首单',
    couponTitle: '优惠券',
}